import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { useIsInBottomSheet } from '../BottomSheet';
import { useDevice } from '../Device';
import { useIsInModal } from '../OverlayContext/ModalContainer';
import { BaseTextField } from './BaseTextField/BaseTextField';
import { MobileTextField } from './MobileTextField';
export const TextField = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { disableMobile } = props;
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    const isInModal = useIsInModal();
    const Component = !isMobileDevice || isInBottomSheet || isInModal || disableMobile ? BaseTextField : MobileTextField;
    return /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
